import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    geofenceEntering: translate({ id: 'gps.eventslist.view.geofenceEntering' }),
    geofenceExiting: translate({ id: 'gps.eventslist.view.geofenceExiting' }),
    noLocation: translate({ id: 'gps.eventslist.view.noLocation' }),
  }))

  return api
}
